/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
  mdiMonitorAccount,
  mdiDatabase,
  mdiTextBox,
  mdiAccountArrowRight,
  mdiAccountTie,
  mdiAccount,
  mdiCog,
  mdiClipboardText,
  mdiBadgeAccount,
  mdiExclamationThick,
  mdiPencilOff,
  mdiAccountCancelOutline,
  mdiClockAlertOutline
} from '@mdi/js'
import CryptoJS from 'crypto-js'

const hrDashboard = {
  to: '/hr-dashboard',
  icon: mdiMonitorAccount,
  label: 'Dashboard'
}

const employeeInfo = {
  to: '/employee-info',
  icon: mdiBadgeAccount,
  label: 'Personal Info'
}

const master = {
  label: 'Master',
  subLabel: 'Submenus Master',
  icon: mdiDatabase,
  menu: [
    {
      to: '/holidays',
      label: 'sidebarFin.holidays',
      icon: mdiDatabase
    },
    {
      to: '/committe-role',
      label: 'sidebarFin.committeRole',
      icon: mdiDatabase
    },
    {
      to: '/career-path',
      label: 'sidebarFin.careerPath',
      icon: mdiDatabase
    },
    {
      to: '/hrresponsibilityrole',
      label: 'Responsibility Role',
      icon: mdiDatabase
    },
    {
      to: '/hrposition',
      label: 'sidebarFin.hrposition',
      icon: mdiDatabase
    },
    {
      to: '/mleave',
      label: 'sidebarFin.mleave',
      icon: mdiDatabase
    },
    {
      to: '/violation',
      label: 'Violation',
      icon: mdiExclamationThick
    },
    {
      to: 'punishment-type',
      label: 'Punishment Type',
      icon: mdiPencilOff
    },
    {
      to: '/punishment-master',
      label: 'Punishment',
      icon: mdiPencilOff
    },
    {
      to: '/template-decree',
      label: 'Template Decree',
      icon: mdiAccountCancelOutline
    }
  ]
}

const workhour = {
  label: 'Workhour',
  subLabel: 'Submenus Punishment',
  icon: mdiClockAlertOutline,
  menu: [
    {
      to: '/trworkhour',
      label: 'Work Hour',
      icon: mdiClockAlertOutline
    }
  ]
}

const punishment = {
  label: 'Punishment',
  subLabel: 'Submenus Punishment',
  icon: mdiDatabase,
  menu: [
    {
      to: '/punishment-transaction',
      label: 'Punishment Transaction',
      icon: mdiPencilOff
    }
  ]
}

const leave = {
  label: 'Leave',
  subLabel: 'Submenus Leave',
  icon: mdiAccountArrowRight,
  menu: [
    {
      to: '/leave-dashboard',
      label: 'Leave Dashboard',
      icon: mdiAccountTie,
      forAccess: [],
      notAccess: []
    },
    {
      to: '/leave-balance',
      label: 'Leave Balance',
      icon: mdiAccountTie
    },
    {
      to: '/leave-request',
      label: 'Leave Request',
      icon: mdiAccountTie
    },
    {
      to: '/leave-addition',
      label: 'Leave Addition',
      icon: mdiAccountTie
    }
  ]
}

const programme = {
  label: 'Programme',
  subLabel: 'Submenus Programme',
  icon: mdiMonitorAccount,
  menu: [
    {
      to: '/programme',
      label: 'sidebarFin.programme',
      icon: mdiMonitorAccount
    }
    // ,
    // {
    //   to: '/programme-exception-time',
    //   label: 'Programme Exception Time',
    //   icon: mdiMonitorAccount
    // }
  ]
}

const training = {
  label: 'Training',
  subLabel: 'Training',
  icon: mdiClipboardText,
  menu: [
    {
      to: '/employee-training',
      label: 'Employee Training',
      icon: mdiClipboardText
    }
  ]
}

const report = {
  label: 'Report',
  subLabel: 'Report',
  icon: mdiTextBox,
  menu: [
    {
      to: '/leave-summary',
      label: 'Leave Summary',
      icon: mdiTextBox
    },
    {
      to: '/punishment-report',
      label: 'Punishment Report',
      icon: mdiTextBox
    }
  ]
}

const settings = {
  label: 'Settings',
  subLabel: 'Submenus Settings',
  icon: mdiCog,
  menu: []
}

const expired = {
  to: '/setting-expired-employee',
  label: 'Setting for Expiring Date',
  icon: mdiCog
}

const employee = {
  to: '/employee',
  label: 'Employees',
  icon: mdiAccount
}

const users = {
  to: '/users',
  label: 'Users',
  icon: mdiAccount
}

const Generals = []
Generals.push(hrDashboard)
Generals.push(employeeInfo)
// Generals.push(employeeInfo)

// if (localStorage.getItem('child')) {
//   const employeeChild = localStorage.getItem('child')

//   if (employeeChild !== '0') {
//     // console.log('cek jumlah child', employeeChild)
//     Generals.push(employeeInfo)
//   }
// }

const Examples = []
Examples.push(master)
Examples.push(workhour)
Examples.push(punishment)
Examples.push(leave)
Examples.push(programme)
Examples.push(training)
Examples.push(report)

// Role
settings.menu = []
settings.menu.push(employee)
if (localStorage.getItem('role')) {
  let check = 0
	const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
  const myArray = decryptedMessage.split(',')

  for (let i = 0; i < myArray.length; i++) {
    if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
      check += 1
    }
  }

  if (check > 0) {
    settings.menu = []
    settings.menu.push(expired)
    settings.menu.push(employee)
    settings.menu.push(users)
  }
}

Examples.push(settings)

export default [
  'General', Generals,
  'Examples', Examples
]
